@if (marginTypeList) {
  <p-select
    appendTo="body"
    (onChange)="onMarginTypeChange($event)"
    [options]="marginTypeList"
    [(ngModel)]="marginType"
    [filter]="true"
    filterBy="label, value"
    [disabled]="disabled()"
    [placeholder]="marginType"
  >
  </p-select>
}
